import { axiosAPI } from 'utils';

export default {
  generateWordAgHelpSegments(params) {
    return axiosAPI
      .post(`api/polly/word-ag-help-segments`, params)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err.response?.data || { success: false, error: err.toString() };
      });
  },
  generateTTS(params) {
    return axiosAPI
      .post(`api/polly/generate-tts`, params)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err.response?.data || { success: false, error: err.toString() };
      });
  },
  getHaitianTtsOptions(locale) {
    const query = locale ? `?locale=${encodeURIComponent(locale)}` : '';
    return axiosAPI
      .get(`api/polly/haitian-tts-options${query}`)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err.response?.data || { success: false, voices: [], accents: [], error: err.toString() };
      });
  },
  getHaitianTtsJobStatus(params) {
    return axiosAPI
      .post(`api/polly/haitian-tts-job-status`, params)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err.response?.data || { success: false, error: err.toString() };
      });
  },
  getElevenLabsSettings() {
    return axiosAPI
      .get(`api/admin/elevenlabs-settings`)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err.response?.data || { success: false, error: err.toString() };
      });
  },
  updateElevenLabsSettings(params) {
    return axiosAPI
      .put(`api/admin/elevenlabs-settings`, params)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err.response?.data || { success: false, error: err.toString() };
      });
  },
  getElevenLabsVoices(locale, options = {}) {
    const params = new URLSearchParams();

    if (locale) params.set('locale', locale);
    if (options.admin === true) params.set('context', 'admin');
    if (options.metadataOnly === true) params.set('metadataOnly', 'true');
    if (options.accent) params.set('accent', options.accent);
    if (options.gender) params.set('gender', options.gender);
    if (options.pageSize) params.set('pageSize', options.pageSize);
    if (options.maxPages) params.set('maxPages', options.maxPages);
    if (options.search) params.set('search', options.search);
    if (options.localeName) params.set('localeName', options.localeName);
    if (options.displayName) params.set('displayName', options.displayName);
    if (options.selectedOnly === true) params.set('selectedOnly', 'true');
    if (options.lastSortId) params.set('lastSortId', options.lastSortId);
    if (options.page !== undefined && options.page !== null) params.set('page', options.page);

    const query = params.toString() ? `?${params.toString()}` : '';

    return axiosAPI
      .get(`api/polly/elevenlabs-voices${query}`)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err.response?.data || { success: false, voices: [], error: err.toString() };
      });
  },
}
